import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import PicklistValueSlider from 'Components/ComponentLibrary/Organisms/PicklistValueSlider/PicklistValueSlider';
import { BodyTextMedium } from 'Packages/FacetDesign/Components';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('name', {
    _component: () => BodyTextMedium,
  }, overrideReadOnly)
  .nameOverride('riskTolerance', {
    _component: () => PicklistValueSlider,
  }, overrideReadOnly);

export default metaOverrideSet;
